/**
 * 订单状态
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/10/9      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from "react";
import { Select } from 'antd';
import PropTypes from "prop-types";
const { Option } = Select;
class OrderStatus extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            list:props.list
        }
    }

    handleChange(value){
        this.props.handleChange(value);
    }

    render(){
        let {list} = this.state;
        return (
            <Select defaultValue={this.props.status} onChange={this.handleChange.bind(this)} popupMatchSelectWidth={false} loading={list.length<0?true:false}>
                <Option value={-1}>{__getServerLanguage('QuanBuZhuangTai')}</Option>
                {list.map(function (item,index) {
                    return <Option key={index} value={item.code}>{item.name}</Option>
                })}
            </Select>
        )
    }
}

OrderStatus.defaultProps = {
    status:-1,
    //下拉切换后的回调
    handleChange:function () {},
    //数据源
    list:[
        {code:0,name:__getServerLanguage('DaiZhiFuDingJin')},
        {code:1,name:__getServerLanguage('JinXingZhong')},
        {code:2,name:__getServerLanguage('DaiZhiFuWeiKuan')},
        {code:3,name:__getServerLanguage('YiWanCheng')},
        {code:4,name:__getServerLanguage('YiQuXiao')},
    ]
}

OrderStatus.propTypes = {
    status:PropTypes.number,
    handleChange:PropTypes.func,
    list:PropTypes.array

}
export default OrderStatus;
